<template>
  <div class="response_table permission_table">
    <table>
      <thead style="">
        <tr>
          <th scope="col" class="name"> {{translate('user.roles.permission_name')}} </th>
          <th scope="col" class="permissions"> {{translate('user.roles.permission_info')}} </th>
          <th scope="col" class="permissions"> {{translate('user.roles.role_list_for_permission')}} </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(permission, permission_key) in permission_list" :key="permission_key" class="role">
          <td :data-label="translate('user.roles.permission_name')" class="name">
            <span>{{ permission.name }}</span>
          </td>
          <td :data-label="translate('user.roles.permission_info')" class="permissions">
            <span>{{ permission.description }}</span>
          </td>
          <td :data-label="translate('user.roles.role_list_for_permission')" class="permissions">
            <span> {{ find_role_list(permission) }} </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'PermissionList',
  props: ['role_list', 'permission_list'],
  data () {
    return {
    }
  },
  methods: {
    find_role_list(permission){
      let list = Object.values(this.role_list).map((role) => {
        if (role.permissions.indexOf(permission.name) > -1){
          return role.name
        }
      }).filter(element => element !== null && element !== undefined)
      let role_list = ''
      list.forEach((role, index) => {
        role_list += role
        if (list.length-1 !== index) role_list += ', '
      })
      return role_list
    }
  }

}

</script>

<style lang="scss" scoped>
.response_table{
  font-size: 14px;

  &.permission_table{
    height: 100%;
    .table_title{
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0;
      height: 25px;
    }
    table{
      height: calc(100% - 33px);
      .name{
        text-align: left;
        width: 40%;
      }
      .permissions{
        text-align: left;
      }
    }
  }
}

</style>
